module.exports = __webpack_public_path__ + "9020e3747a4f730fcbb7868c35fba83b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/black_cured.png
 ** module id = 994
 ** module chunks = 0
 **/